// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__1PKAI","lds-dual-ring":"spinner_lds-dual-ring__ArJBb"};